var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKitchenDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47.5 47.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.25,0,0,-1.25,0,47.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(20,35.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,0.829 -0.672,1.5 -1.5,1.5 -2.329,1.5 -3,0.829 -3,0 L -3,-5.775 -3,-9 -3,-9.5 c 0,-0.552 -0.448,-1 -1,-1 -0.552,0 -1,0.448 -1,1 l 0,0.5 0,3.5 0,5.5 C -5,0.829 -5.671,1.5 -6.5,1.5 -7.329,1.5 -8,0.829 -8,0 l 0,-5.5 0,-3.5 0,-0.5 c 0,-0.552 -0.448,-1 -1,-1 -0.552,0 -1,0.448 -1,1 l 0,0.5 0,3.225 0,5.775 c 0,0.829 -0.671,1.5 -1.5,1.5 C -12.329,1.5 -13,0.829 -13,0 l 0,-9 c 0,-0.127 0.021,-0.249 0.051,-0.367 C -12.979,-9.574 -13,-9.784 -13,-10 c 0,-2.316 1.75,-5.957 4,-6.442 L -9,-32 c 0,-1.381 1.119,-2.5 2.5,-2.5 1.381,0 2.5,1.119 2.5,2.5 l 0,15.558 c 2.25,0.485 4,4.126 4,6.442 0,0.216 -0.021,0.426 -0.051,0.633 C -0.021,-9.249 0,-9.127 0,-9 l 0,9 z",
    id: "path22",
    fill: "#4B5563"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(28.5,37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.104,0 -0.204,-0.019 -0.306,-0.031 -0.37,-0.021 -0.433,0 -0.5,0 c -2.209,0 -5,-5.477 -5,-11 0,-4.658 1.275,-8.561 3,-9.672 l 0,-12.828 c 0,-1.381 1.119,-2.5 2.5,-2.5 1.381,0 2.5,1.119 2.5,2.5 l 0,31 C 2.5,-1.119 1.381,0 0,0",
    id: "path26",
    fill: "#4B5563"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenDark);
export default __webpack_public_path__ + "static/media/kitchen-dark.6528b43fc22991a80c3240f93e99fa36.svg";
export { ForwardRef as ReactComponent };